import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ApplicationsList from './ApplicationsList/ApplicationsList';
import ApplicationShow from './ApplicationShow/ApplicationShow';
import ApplicationDelete from './ApplicationDelete/ApplicationDelete';

const Applications = ({ match }) => {
    return (
        <div className="Applications">
            <ContainerWrapper container="applications">
                <Route exact path={ match.path } component={ApplicationsList} />
                <Route exact path={ `${ match.url }/show/:applicationId` } component={ApplicationShow} />
                <Route exact path={ `${ match.url }/delete/:applicationId` } component={ApplicationDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Applications;

